import styled from "styled-components";

export const PromosSeoContainerWrapper = styled.div<{ isMobile: boolean }>`
  background: var(--fd-colors-background-base);
  padding: ${({ isMobile }) => (isMobile ? "0" : "var(--fd-space-space-4)")};
`;

export const PromosSeoContainer = styled.div<{ isMobile: boolean }>`
  height: 100%;
  background: var(--fd-colors-background-surface, #fff);
  padding: var(--fd-space-space-4);
  ${({ isMobile }) =>
    !isMobile &&
    `
      border-radius: var(--fd-radii-border-radius-020);
    `}

  a {
    color: var(--fd-colors-content-link);
    text-decoration: none;
    display: inline-block;
    vertical-align: baseline;
  }
`;
